/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettingService } from './../../app-setting.service';

/**
 * Sets the anti-forgery header required by VM Online
 */
@Injectable()
export class HttpInterceptorSetXsrf implements HttpInterceptor {
	private appSettingService = inject(AppSettingService);

	apiUrl: string;

	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const isVmonlineUrl =
			this.appSettingService.appSetting != null &&
			request.url.startsWith(this.appSettingService.appSetting.apiUrl);

		if (isVmonlineUrl) {
			request = this.setXsrfHeader(request);
		}

		return next.handle(request);
	}

	private setXsrfHeader(request: HttpRequest<any>): HttpRequest<any> {
		const xsrfCookieName = this.appSettingService.appSetting.xsrfCookieName;
		const requestToken = this.getCookieValue(xsrfCookieName);

		if (requestToken) {
			request = request.clone({
				headers: request.headers.set('X-' + xsrfCookieName, requestToken),
			});
		}

		return request;
	}

	private getCookieValue(cookieName: string): string {
		const allCookies = decodeURIComponent(document.cookie)
			.split(';')
			.map((x) => x.trim());
		for (const cookie of allCookies) {
			if (cookie.startsWith(cookieName + '=')) {
				return cookie.substring(cookieName.length + 1);
			}
		}
		return '';
	}
}
